module.exports = __webpack_public_path__ + "static/9-677c76cb6e5e7e76e33d7594a15df70a.jpeg";